import { fetchAuthSession } from 'aws-amplify/auth';

export async function getAuthToken(): Promise<string> {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) {
    throw new Error('No auth token available');
  }
  return token;
}

export async function getRefreshedAuthToken(): Promise<string> {
  const session = await fetchAuthSession({ forceRefresh: true });
  const token = session.tokens?.idToken?.toString();
  if (!token) {
    throw new Error('No auth token available after refresh');
  }
  return token;
}

export async function refreshUserData(): Promise<void> {
  const { useUserStore } = await import('@/stores/user');
  const { decodeJwt } = await import('@/lib/utils/jwt-utils');

  const token = await getAuthToken();
  const decodedToken: any = decodeJwt(token);

  const isSuperuser = decodedToken['cognito:groups']?.includes('SystemAdmin');

  if (isSuperuser) {
    useUserStore.setState({
      currentUserDetails: {
        id: decodedToken['cognito:username'],
        email: decodedToken.email,
        firstName: null,
        lastName: null,
        preferredName: null,
      },
      currentUserPermissions: { isSuperuser: true, orgPermissions: null },
    });
    return;
  }

  const parsedOrgAccess = JSON.parse(decodedToken.OrganizationAccess);
  const currentLabId = useUserStore.getState().mostRecentLab.LaboratoryId;

  useUserStore.setState({
    currentUserDetails: {
      id: decodedToken['cognito:username'],
      email: decodedToken.email,
      firstName: decodedToken.FirstName ?? null,
      lastName: decodedToken.LastName ?? null,
      preferredName: decodedToken.PreferredName ?? null,
    },
    currentUserPermissions: {
      isSuperuser: false,
      orgPermissions: parsedOrgAccess,
    },
    currentOrg: {
      OrganizationId: decodedToken.DefaultOrganization || Object.keys(parsedOrgAccess)[0],
    },
    mostRecentLab: {
      LaboratoryId: currentLabId || decodedToken.DefaultLaboratory || null,
    },
  });
}
